module.exports = __webpack_public_path__ + "img/blimpy1.a3160292.jpg";